import axios from 'axios'
import constants from '../../../../src/constants'
import { User } from '../../../redux/user'
import { CorpWaterlineInventoryResponse, WaterlineInventoryItem } from './types'
import { mapWaterlineInventoryToItem } from '../../practice/waterline/utils'

const getCorpWaterlineCustomer = async (customerNumber: string, groupCustomerNumbers?: string[]) => {
  const currentYear = new Date().getFullYear()
  const startYear = currentYear - 1
  const startDate = new Date(startYear, 0, 1).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric'})

  let query = `?fromDate=${startDate}`
  if(groupCustomerNumbers?.length) query += `&groupCustomerNumbers=${JSON.stringify(groupCustomerNumbers)}` 

  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-test-results/corp-children${query}`)

  return data
}

const getCorpWaterlineInventory = async (customerNumber: string, currentUser: User | null, groupCustomerNumbers?: string[]) => {
  const response = await axios.get<CorpWaterlineInventoryResponse>(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-inventory/corp-children`)
  let practices = response.data?.practices ?? []

  if (currentUser?.available_groups && currentUser?.is_corporate && currentUser?.access_level === 'admin') {
    const availableGroups = currentUser.available_groups.map(group => group.group_id)

    practices = practices.filter((practice) => {
      if (practice.members.length > 0) {
        for (let i = 0; i < practice.members.length; i++) {
          return availableGroups.indexOf(practice.members[i].group_id) > -1;
        }
      }
    })
  }

  const inventory = practices.flatMap((practice) =>
    (practice.inventory ?? [])
      .filter((item) => item.item_subcategory?.toLowerCase() !== 'accs')
      .map((item): WaterlineInventoryItem => ({
        ...mapWaterlineInventoryToItem(item, item.customer_number),
        childCustomerName: practice.name ?? '',
      }))
  )

  return inventory
}

export {
  getCorpWaterlineCustomer,
  getCorpWaterlineInventory,
}
